import { MAIN_EMAIL, PHONE } from "@/content";
import { Mail, Phone } from "lucide-react";

const telHref = `tel:${PHONE.replace(/\s/g, "")}`;

export const Contact = ({ t }) => (
  <section id="contact" className="bg-ink text-paper py-24 md:py-32" data-testid="contact-section">
    <div className="max-w-6xl mx-auto px-6 text-center">
      <p className="lb text-brasssoft">{t.contactLabel}</p>
      <h2 className="dd mt-6 reveal">{t.contactTitle}</h2>
      <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
        <a
          href={`mailto:${MAIN_EMAIL}`}
          className="group sv inline-flex items-center gap-3 bg-brassbtn text-ink px-8 py-4 text-[17px] transition-colors duration-200 hover:bg-brasssoft"
          data-testid="contact-email-button"
        >
          <Mail size={18} /> {MAIN_EMAIL}
          <span className="transition-transform duration-200 group-hover:translate-x-1">→</span>
        </a>
        <a
          href={telHref}
          className="sv inline-flex items-center gap-3 border border-paper/40 px-8 py-4 text-[17px] whitespace-nowrap transition-colors duration-200 hover:bg-paper hover:text-ink"
          data-testid="contact-phone-button"
        >
          <Phone size={18} /> {PHONE}
        </a>
      </div>
      <p className="sv mt-8 text-sm text-paper/70 max-w-md mx-auto">{t.contactText}</p>
    </div>
  </section>
);
